import { createElement } from 'react'
import { InWinImage } from 'routes/shared/components'

export const createInWinImage = ({ value }) =>
  createElement(InWinImage, {
    source: value,
    alt: value,
    style: { width: 56 },
  })
